import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { UploadFile, UploadInput, UploadOutput } from 'ngx-uploader';
import { ConfirmationData } from '../../models/confirm.model';
import { ApplicationService, ContentService, StructuredService } from '../../services';

@Component({ templateUrl: 'edit-thumbnail.dialog.html' })
export class EditThumbnailDialog implements OnInit {
  public dragOver;
  public thumbnail: UploadFile;
  public thumbnailUploadInput: EventEmitter<UploadInput>;

  public imageChangedEvent: any = '';
  public croppedImage: any = '';
  constructor(
    public dialogRef: MatDialogRef<EditThumbnailDialog>,
    private structuredService: StructuredService,
    private contentService: ContentService,
    private toastr: ToastrService,
    private appService: ApplicationService,
    @Inject(MAT_DIALOG_DATA) public data) {
  }

  public ngOnInit(): void {
    this.thumbnailUploadInput = new EventEmitter<UploadInput>();
  }

  public onThumbnailUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') {
      this.startThumbnailUpload();
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      this.thumbnail = output.file;
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      this.thumbnail = output.file;
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut' || output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'done') {
      if (output.file.responseStatus == 200) {
        this.dialogRef.close(output.file.response);
        this.toastr.success('Thumbnail successfully updated.');
      } else if (output.file.responseStatus >= 400) {
        this.toastr.error('Thumbnail not updated.');
      }
    }
  }

  public fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  public imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  public deleteThumb() {
    switch (this.data.type) {
      case 'structuredContent':
        this.structuredService.deleteThumbnail(this.data._id).subscribe(() => { this.dialogRef.close(); });
        break;
      case 'content':
        this.contentService.deleteThumbnail(this.data._id).subscribe((data) => { this.dialogRef.close(data); });
        break;
      case 'app':
        this.appService.deleteThumbnail(this.data._id).subscribe(() => { this.dialogRef.close(); });
        break;
      default:
        break;
    }
  }

  public startThumbnailUpload(): void {
    switch (this.data.type) {
      case 'structuredContent':
        this.thumbnailUploadInput.emit(this.structuredService.putThumbnail(this.data._id));
        break;
      case 'content':
        this.thumbnailUploadInput.emit(this.contentService.putThumbnail(this.data._id));
        break;
      case 'app':
        this.thumbnailUploadInput.emit(this.appService.putThumbnail(this.data._id));
        break;
      default:
        break;
    }
  }
}
